export default "__VITE_ASSET__F6cQ0R9r__"